import { RSAA, getJSON } from 'redux-api-middleware';
import * as analytics from '../../utils/analytics';
import { ANALYTICS_ERROR } from '../../utils/constants';
import { technicalErrorPage } from '../../store/dataCapture';

export const FETCH_CUSTOMERBYID = 'FETCH_CUSTOMERBYID';
export const FETCH_CUSTOMERBYID_SUCCESS = 'FETCH_CUSTOMERBYID_SUCCESS';
export const FETCH_CUSTOMERBYID_FAILED = 'FETCH_CUSTOMERBYID_FAILED';
export const fetchCustomerById = (customerId) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/${customerId}`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: FETCH_CUSTOMERBYID,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_CUSTOMERBYID_SUCCESS,
        meta: (_action, _state) => {
          analytics.updateCustomer(customerId);
          return { loading: false };
        }
      },
      {
        type: FETCH_CUSTOMERBYID_FAILED,
        meta: (_action, _state) => {
          analytics.error({
            errorCode: 0,
            errorMessage: ANALYTICS_ERROR.FETCH_CUSTOMERBYID_FAILED
          });
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILED = 'FETCH_CUSTOMERS_FAILED';
export const fetchCustomers = () => ({
  [RSAA]: {
    endpoint: ':api_paas_url/banks/:bank_id/customers',
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: FETCH_CUSTOMERS,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_CUSTOMERS_SUCCESS,
        payload: (_action, _state, res) =>
          getJSON(res).then((json) => {
            res.json = json;
            return json;
          }),
        meta: (_action, _state, res) => ({
          nextAction:
            res && res.json && res.json.customers && res.json.customers.length > 0
              ? fetchCustomerById(res.json.customers[0].id)
              : technicalErrorPage(),
          loading: true
        })
      },
      {
        type: FETCH_CUSTOMERS_FAILED,
        meta: { nextAction: technicalErrorPage(), loading: false }
      }
    ]
  }
});

export const FETCH_MARKETING_PREFERENCES = 'FETCH_MARKETING_PREFERENCES';
export const FETCH_MARKETING_PREFERENCES_SUCCESS = 'FETCH_MARKETING_PREFERENCES_SUCCESS';
export const FETCH_MARKETING_PREFERENCES_FAILED = 'FETCH_MARKETING_PREFERENCES_FAILED';
export const getMarketingPreferences = (businessId) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/${businessId}/marketconsent`,
    method: 'GET',
    headers: {
      'x-bpi-version': '0.8.0'
    },
    types: [
      {
        type: FETCH_MARKETING_PREFERENCES,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_MARKETING_PREFERENCES_SUCCESS,
        meta: {
          loading: false
        }
      },
      {
        type: FETCH_MARKETING_PREFERENCES_FAILED,
        meta: {
          loading: false
        }
      }
    ]
  }
});
